import { render, staticRenderFns } from "./AdminHomeEventsCard.vue?vue&type=template&id=4907042c&scoped=true"
import script from "./AdminHomeEventsCard.vue?vue&type=script&lang=js"
export * from "./AdminHomeEventsCard.vue?vue&type=script&lang=js"
import style0 from "./AdminHomeEventsCard.vue?vue&type=style&index=0&id=4907042c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4907042c",
  null
  
)

export default component.exports